<template>
  <div id="ElectricityCharge">
    <div id="user">
      <div class="clearfix">
        <h3>用户列表</h3>
      </div>
      <div class="there">
        <div class="there-item">
          <el-input placeholder="输入关键字进行过滤" v-model="filterText">
          </el-input>
          <div class="there-btn"></div>
        </div>
        <el-tree
          class="filter-tree"
          :data="data"
          :props="defaultProps"
          default-expand-all
          :filter-node-method="filterNode"
          ref="tree"
        >
        </el-tree>
      </div>
    </div>
    <div id="text">
      <h3>用户列表</h3>
      <div class="table">
        <div class="input-timer">
          <el-form ref="form" :model="Form" label-width="80px" size="mini">
            <el-form-item>
              <el-select v-model="Form.name" placeholder="请选择活动区域">
                <el-option label="区域一" value="shanghai"></el-option>
                <el-option label="区域二" value="beijing"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="Form.test" placeholder="请选择活动区域">
                <el-option label="区域一" value="shanghai"></el-option>
                <el-option label="区域二" value="beijing"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-col :span="11">
                <el-date-picker
                  v-model="Form.arr"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </el-col>
            </el-form-item>
            <el-form-item size="large">
              <el-button type="primary" @click="onclickSubmit">查询</el-button>
            </el-form-item>
          </el-form>
          <div class="logo"></div>
          <p>导出列表</p>
        </div>
        <div class="table-user">
          <el-form ref="form" :model="sizeForm" label-width="80px" size="mini">
            <el-form-item prop="age">
              <el-input type="age" v-model="sizeForm.age"></el-input>
            </el-form-item>

            <el-form-item size="large">
              <el-button type="primary" @click="onSubmit">搜索</el-button>
            </el-form-item>
          </el-form>
          <el-table :data="tableData" stripe style="width: 100%">
            <el-table-column prop="date" label="用户名" width="180">
            </el-table-column>
            <el-table-column prop="name" label="用户号" width="180">
            </el-table-column>
            <el-table-column prop="address" label="电费号"> </el-table-column>
            <el-table-column prop="address" label="表类型"> </el-table-column>
            <el-table-column prop="address" label="充值金额"> </el-table-column>
            <el-table-column prop="address" label="充值方式"> </el-table-column>
            <el-table-column prop="address" label="时间"> </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ElectricityCharge",
  data() {
    return {
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄",
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1519 弄",
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1516 弄",
        },
      ],
      sizeForm: {
        age: "",
      },
      Form: {
        arr: "",
        name: "",
        test: "",
      },
      filterText: "",
      data: [
        {
          id: 1,
          label: "东区",
          children: [
            {
              id: 4,
              label: "二级 1-1",
              children: [
                {
                  id: 9,
                  label: "三级 1-1-1",
                },
                {
                  id: 10,
                  label: "三级 1-1-2",
                },
              ],
            },
          ],
        },
        {
          id: 2,
          label: "西区",
          children: [
            {
              id: 5,
              label: "某某大楼",
              children: [
                {
                  id: 11,
                  label: "某某企业",
                },
                {
                  id: 13,
                  label: "某某企业",
                },
              ],
            },
            {
              id: 6,
              label: "某某大楼",
            },
          ],
        },
        {
          id: 3,
          label: "北区",
          children: [
            {
              id: 7,
              label: "二级 3-1",
            },
            {
              id: 8,
              label: "二级 3-2",
            },
          ],
        },
        {
          id: 3,
          label: "北区",
          children: [
            {
              id: 7,
              label: "二级 3-1",
            },
            {
              id: 8,
              label: "二级 3-2",
            },
          ],
        },
      ],
      defaultProps: {
        children: "children",
        label: "label",
      },
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    onclickSubmit(){
 console.log(this.Form.arr,
        this.Form.name,
        this.Form.test);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    onSubmit() {
      console.log(this.sizeForm.age);
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
  },
};
</script>
<style lang="less" scoped>
#ElectricityCharge {
  width: 100%;
  height: 100%;
  display: flex;
  #user {
    .w(327);
    height: 100%;
    background-color: #fff;

    .clearfix {
      padding: 23rem 0 23rem 24rem;
      border-bottom: 1rem solid rgba(0, 43, 102, 0.28);
      h3 {
        width: 72px;
        height: 18px;
        font-size: 18px;
        font-weight: bold;
        color: #333333;
      }
    }
    .there-item {
      display: flex;
      padding-right: 24rem;
      margin-top: 20rem;
      .there-btn {
        .w(20);
        .h(20);
        background-color: red;
        margin-top: 14rem;
      }
    }
  }
  #text {
    height: 100%;
    background-color: #fff;
    .w(1256);
    margin-left: 8rem;
    padding: 23rem 24rem 23rem 24rem;
    h3 {
      width: 72px;
      height: 18px;
      font-size: 18px;
      font-weight: bold;
      color: #333333;
    }
    .table {
      margin-top: 23rem;
    }
  }
  .input-timer {
    display: flex;
    .logo {
      .w(20);
      .h(19);
      background-color: red;
      margin-left: 188rem;
      margin-top: 10rem;
    }
    p {
      width: 72px;
      height: 18px;
      margin-top: 5rem;
      font-size: 18px;
      font-weight: 500;
      color: #333333;
      margin-left: 7rem;
    }
  }
  .soso {
    margin-left: 24rem;
  }
}
</style>